import React, { FC } from 'react'
import { HoskingsButton } from '@components/ui'
import { connectHits, Pagination } from 'react-instantsearch-dom'
import cn from 'clsx'
import StatsWithProgressBar from '@components/common/StatsWithProgressBar'

const GRID_LAYOUT_4 = 'GRID_LAYOUT_4'
const GRID_LAYOUT_1 = 'GRID_LAYOUT_1'

interface props {
  hits: []
  HitComponent: any
  hasMore: boolean
  refineNext: any
  totalProducts?: any
  gridSelectionDesktop?: any
  gridSelectionMobile?: any
  pathname?: any
  page: number
}

const AlgoliaCustomHits: FC<props> = ({
  hits,
  HitComponent,
  totalProducts,
  gridSelectionDesktop,
  gridSelectionMobile,
  pathname,
  page,
}) => {
  const gridDesktop =
    gridSelectionDesktop === GRID_LAYOUT_4 ? `lg:grid-cols-4` : `lg:grid-cols-6`
  const gridMobile =
    gridSelectionMobile === GRID_LAYOUT_1 ? `grid-cols-1` : `grid-cols-2`

  let filteredHits
  if (pathname && pathname.includes('collections')) {
    //hides sold out products from collection pages
    filteredHits = hits.filter((hit: any) => hit?.variants_inventory_count > 0)
  } else {
    //only displays a sold out product if it's the closest search match
    filteredHits = hits.filter((hit: any, index) => {
      return hit?.variants_inventory_count || index === 0
    })
  }
  // const modifier = page - 1;
  // let bottomRange = page == 1 ? 1 : (page - 1 * 36) + 1;
  // let topRange = page == 1 ? hits.length : bottomRange + hits.length
  // const currentProductRange = `${bottomRange} - ${topRange}`
  return (
    <div>
      <div className="wrapper">
        <div
          className={cn(
            `pb-11 pt-6 grid ${gridMobile} ${gridDesktop} gap-5 gap-y-8 lg:gap-8 lg:gap-y-10`
          )}
        >
          {filteredHits.map((hit: any, index: number) => {
            return (
              <div key={index}>
                <HitComponent
                  key={index}
                  hit={hit}
                  isSoldOut={hit.variants_inventory_count === 0}
                />
              </div>
            )
          })}
        </div>
        <div className="flex justify-center pb-15 pt-5 lg:pt-10 lg:pb-20 body-2 text-text-subdued">
          {
            // https://www.algolia.com/doc/deprecated/instantsearch/react/v6/api-reference/pagination/
          }
          <Pagination
            translations={{
              previous: 'Prev',
              next: 'Next',
              first: 'First',
              last: 'Last',
            }}
          />
          <style jsx global>
            {`
              .ais-Pagination-list {
                display: flex;
              }
              .ais-Pagination-link {
                padding: 10px 15px;
                border: solid 1px #f5f5f5;
              }
              .ais-Pagination-link--selected {
                background-color: #f5f5f5;
                font-weight: 600;
              }
            `}
          </style>
        </div>
        {/*<div className="lg:pb-20">*/}
        {/*  <div className="body-2 text-text-subdued flex justify-center">*/}
        {/*    Showing <span className="px-1">{currentProductRange}</span> of{' '}*/}
        {/*    <span className="pl-1">{totalProducts}</span>*/}
        {/*  </div>*/}
        {/*  {filteredHits.length > 0 && <StatsWithProgressBar hits={filteredHits} />}*/}
        {/*</div>*/}
      </div>
    </div>
  )
}

export default connectHits(AlgoliaCustomHits)
